import { Card, IconQuestion, WithPopover } from '@procurify/ui'
import { useSelector } from 'react-redux'

import {
  BudgetCategoryAttributeDescriptions,
  type IBudgetCategoryAttributeDescription,
} from '@webapp/components/Budgets/BudgetCategoryAttributeDescriptions'
import { makeSelectFeatureSwitches } from '@webapp/core/stores/global'
import { useProcurifyIntl } from '@webapp/hooks'
import { BudgetCategoryAttributesPopoverStyled } from './styles/BudgetCategoryCardAttributesPopoverStyled'
import messages from '../../messages'

export interface IBudgetCategoryCardAttributesPopoverProps {
  departments?: string[]
  accountCodes?: string[]
  /** Rows shown after Account Code, already formatted, in the order given. */
  customFieldAttributes?: IBudgetCategoryAttributeDescription[]
  isSourceOfTruth?: boolean
}

export const BudgetCategoryCardAttributesPopover = ({
  departments,
  accountCodes,
  customFieldAttributes = [],
  isSourceOfTruth,
}: IBudgetCategoryCardAttributesPopoverProps) => {
  const intl = useProcurifyIntl()
  const { enable_flexible_spend_tracking: isFlexibleSpendTrackingEnabled } =
    useSelector(makeSelectFeatureSwitches())

  const attributes = [
    ...(departments?.length
      ? [
          {
            label: intl.formatMessage(messages.secondaryOrgCategoryLabel),
            value: departments,
          },
        ]
      : []),
    ...(accountCodes?.length
      ? [
          {
            label: intl.formatMessage(messages.accountCodesLabel),
            value: accountCodes,
          },
        ]
      : []),
    ...customFieldAttributes,
  ]

  const renderPopoverContent = () => {
    return (
      <Card.Content>
        <BudgetCategoryAttributeDescriptions
          attributes={attributes}
          isSourceOfTruth={isSourceOfTruth}
        />
      </Card.Content>
    )
  }

  return (
    <BudgetCategoryAttributesPopoverStyled>
      <WithPopover content={renderPopoverContent()}>
        <IconQuestion
          ariaLabel={intl.formatMessage(
            isFlexibleSpendTrackingEnabled
              ? messages.attributesPopoverLabel
              : messages.oldAttributesPopoverLabel
          )}
          ml={0.25}
        />
      </WithPopover>
    </BudgetCategoryAttributesPopoverStyled>
  )
}

BudgetCategoryCardAttributesPopover.displayName =
  'BudgetCategoryCardAttributesPopover'
